import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import CursoForm from './CursoForm';
import { useSelector } from "react-redux";
import CursoTable from "./CursoTable";
import Typography from '@mui/material/Typography';

const useStyles = makeStyles({
    container: {
        marginTop: '20px'
    },
    paper: {
        padding: '20px',
    },
    table: {
        paddingTop: '20px;',
        margin: '20px'
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});

export default function CursoContainer() {
    const curso = useSelector(state => state.curso);
    const classes = useStyles();

    return (
        <div>
            <Container className={classes.paper} component={Paper}>
                <Typography className={classes.title} variant="h6">
                    Cursos
                </Typography>
                {curso ?
                    <>
                        <Grid style={{ marginBottom: '20px' }} container spacing={2}>
                            <Grid size={4}>
                                <CursoForm />
                            </Grid>

                        </Grid>
                    </> :
                    <CursoTable />
                }

            </Container>
        </div>
    );
}